<template>
	<div style="padding: 20px">
		<button class="btn btn-xs no-print btn-default" type="button" @click="_print()" style="margin-bottom: 10px">
			<i class="fa icon-imprimir r-print"></i> {{ _traducao('global', 'imprimir').toUpperCase() }}
		</button>

		<button
			class="btn btn-xs no-print pull-right btn-default"
			type="button"
			@click="voltarParaOLogin"
			style="margin-bottom: 10px"
		>
			<i class="fa icon-left r-print"></i> {{ _traducao('global', 'voltar').toUpperCase() }}
		</button>

		<print-visualizacao-rel-prev :id="id" />
	</div>
</template>

<script>
import PrintVisualizacaoRelPrev from '@/modules/layout/seguranca-operacional/relatorio-prevencao/components/print-visualizacao.vue'

export default {
	name: 'LoginRelatorioPrevencaoVisualizar',

	components: {
		PrintVisualizacaoRelPrev
	},

	props: {
		id: {
			type: [String, Number],
			required: false,
			default: '0'
		}
	},

	methods: {
		voltarParaOLogin() {
			this.$router.replace({name: 'login'})
		}
	}
}
</script>